import React from 'react';
import { Typography } from '~/libs/ui/atoms/Typography';
import { Breadcrumbs, BreadcrumbsItem } from '~/libs/ui/atoms/Breadcrumbs';

import { AVAILABILITY_PAGE_WIDTH } from '../constants';

export interface HeaderProps {
	breadcrumbs: BreadcrumbsItem[];
	title: string;
}

export function Header({ breadcrumbs, title }: HeaderProps) {
	return (
		<div className='w-full pt-2 pb-3.5 border-b border-gray-200 bg-cBlue-50'>
			<div className={`${AVAILABILITY_PAGE_WIDTH} mx-auto px-[40px]`}>
				<Breadcrumbs list={breadcrumbs} />

				<div className='mb-3 flex w-full justify-between items-start'>
					<div className='pt-4 flex items-center justify-center'>
						<Typography level={2} weight='font-bold' color='cBlue-800'>
							{title}
						</Typography>
					</div>
				</div>
			</div>
		</div>
	);
}
